// Máscara para telefone (fixo ou celular)
export const applyPhoneMask = (value) => {
    if (!value) return '';
    
    value = value.replace(/\D/g, '').slice(0, 11); // Apenas números e máximo 11 dígitos
  
    if (value.length <= 10) {
      // Telefone fixo (ex: (16) 3333-3333)
      return value.replace(/^(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3').trim();
    }
  
    // Celular (ex: (16) 99999-9999)
    return value.replace(/^(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3').trim();
  };
  
  // Máscara para CEP (ex: 14050-100)
  export const applyZipCodeMask = (value) => {
    if (!value) return '';
    return value.replace(/\D/g, '').slice(0, 8).replace(/^(\d{5})(\d{0,3})/, '$1-$2').trim();
  };
  
  // Máscara para CPF (ex: 123.456.789-00)
  export const applyCpfMask = (value) => {
    if (!value) return '';
    value = value.replace(/\D/g, '').slice(0, 11); // Apenas números e máximo 11 dígitos
    return value.replace(/^(\d{3})(\d{3})(\d{3})(\d{0,2})/, '$1.$2.$3-$4').trim();
  };

  // Busca endereço via API do ViaCEP
  export const fetchAddressByZipCode = async (zipCode) => {
    const cleanZip = zipCode.replace(/\D/g, '');
    if (cleanZip.length !== 8) return null;
  
    try {
      const response = await fetch(`https://viacep.com.br/ws/${cleanZip}/json/`);
      const data = await response.json();
  
      if (data.erro) return null;
      return data;
    } catch (error) {
      console.error('Erro ao buscar endereço:', error);
      return null;
    }
  };
  